export default {"src":"/_next/static/media/apple-store.fc981588.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};